import React from "react";

const PageNotFound = () => {
  return (
    <div
      style={{
        textAlign: "center",
        fontSize: "48px",
        diplay: "block",
        marginLeft: "auto",
        marginright: "auto",
        width: "100%",
        paddingTop: "300px",
      }}
    >
      PageNotFound
    </div>
  );
};

export default PageNotFound;
